exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".graph-group{width:100%;display:flex;flex-wrap:wrap}.graph-group>div{width:50%;border:gray solid thin}\n", ""]);
